import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn, ManyToOne,  JoinColumn} from "typeorm";
import { DeheadingQAQC } from "./de-heading-qa-qc.entity";

@Entity("deheading_sample")
export class DeheadingSample {

    @PrimaryGeneratedColumn("increment", { name: 'deheading_sample_id' })
    deheadingSampleId: number;

    @Column("int", {
        name: "deheading_qaqc_id"
    })
    qaQcId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'sample_no'
    })
    sampleNo: number;


    @Column({
        type: 'int',
        nullable: false,
        name: 'temperature'
    })
    temperature: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "discoloration"
    })
    discoloration: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "deterioration"
    })
    deterioration: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "soft_tail"
    })
    softTail: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "black_tail"
    })
    blackTail: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "broken_unusable"
    })
    brokenOrUnUsable: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "improper_deheading"
    })
    improperDeheading: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "brown_meat"
    })
    brownMeat: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "hanging_meat_throat"
    })
    hangingMeatOrThroat: string;

    @Column('int', {
        nullable: false,
        name: "plant_id"
    })
    plantId: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => DeheadingQAQC, qaqc => qaqc.deheadingSampleInfo, { nullable: false })
    @JoinColumn({ name: "deheading_qaqc_id" })
    sampleInfo: DeheadingQAQC;
}